module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ../lodash/extend.js
// module id = 1003
// module chunks = 22